const QA_SUPER_DOMAIN_SUFFIX = ".futureplc.engineering";
const VANILLA_QA_SEGMENT = ".van-qa.";

export const isVanillaQaHostname = (hostname: string): boolean => {
  if (typeof hostname !== "string" || hostname.length === 0) {
    return false;
  }

  return (
    hostname.includes(VANILLA_QA_SEGMENT) &&
    hostname.endsWith(QA_SUPER_DOMAIN_SUFFIX)
  );
};
